import { Toaster } from "react-hot-toast";
import "./toast.css";

/** Mount once at app root (see `src/index.js`). */
export default function AppToaster() {
  return (
    <Toaster
      position="top-center"
      gutter={10}
      containerClassName="sendo-toaster"
      containerStyle={{ top: 72, zIndex: 10050 }}
      toastOptions={{
        duration: 3000,
        className: "sendo-toast",
        style: {
          fontSize: "14px",
          fontWeight: 600,
          borderRadius: "8px",
          padding: "12px 16px",
          maxWidth: "420px",
          boxShadow: "0 4px 14px rgba(0, 0, 0, 0.18)",
        },
        success: {
          className: "sendo-toast sendo-toast--success",
          iconTheme: { primary: "#FFC107", secondary: "#1a1a1a" },
        },
        error: {
          className: "sendo-toast sendo-toast--error",
          iconTheme: { primary: "#ef5350", secondary: "#fff" },
        },
        loading: {
          className: "sendo-toast sendo-toast--loading",
          iconTheme: { primary: "#FFC107", secondary: "#1a1a1a" },
        },
      }}
    />
  );
}
